import { Component, Fragment, h, Prop } from '@stencil/core';
import BackIcon from '../../atoms/svg-elements/back-icon';
import { Article, DetailsComponents, DetailsMode, Picker } from '../utils/types';
import { t } from '../../../redux/utils';
import { EnabledDisabled } from '../../../types/types';
import { Cart } from '../../../redux/types';

@Component({
  tag: 'rtr-article-details-template',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrArticleDetailsTemplate {
  @Prop() article: Article;
  @Prop() picker: Picker;
  @Prop() detailsComponent: DetailsComponents;
  @Prop() scrollToCalendar: boolean;
  @Prop() showLocation: EnabledDisabled;
  @Prop() mode: DetailsMode;
  @Prop() cart: Cart;

  get backText() {
    return t('details.back');
  }

  render() {
    return (
      <Fragment>
        <div class="ADWrapper">
          {this.detailsComponent.showFullGallery && (
            <div class="ADCFullGallery">
              <div class="ADCFullGalleryHeader">
                <span class="ADBackButton" onClick={this.detailsComponent.onBackButtonClick}>
                  <BackIcon />
                  {this.backText}
                </span>
              </div>
              <div class="ADCFullGalleryInner">
                <rentware-spacer size="M" />
                <rtr-article-details-gallery-full images={this.article.images} name={this.article.name} onShowFullGallery={this.detailsComponent.onShowFullGallery} />
              </div>
              <rentware-spacer size="M" />
            </div>
          )}

          <rtr-article-details-template-no-gallery
            article={this.article}
            picker={this.picker}
            detailsComponent={this.detailsComponent}
            scrollToCalendar={this.scrollToCalendar}
            showLocation={this.showLocation}
            mode={this.mode}
          />

          <rentware-spacer size="M" />

          <rtr-article-details-in-cart
            article={this.article}
            picker={this.picker}
            detailsComponent={this.detailsComponent}
            cart={this.cart}
          />
        </div>

        <div class="ADModal" onClick={this.detailsComponent.onCloseButtonClick} />
      </Fragment>
    );
  }
}
